export class ActionConstant {
    static actionSaveOrderMoneyTmp: string = "saveOrderMoneyTmp";
    static actionSaveOrder: string = "saveOrder";
    static ACTION_CONFIRM_LOGIN: string = "action_confirm_login";
}
